/* eslint no-unused-vars: 0 */
import { html } from "@ui5/webcomponents-base/dist/renderer/LitRenderer.js";
function block0(context, tags, suffix) { return html `<td tabindex="-1" part="cell" role="cell"><slot></slot></td>`; }
export default block0;
//# sourceMappingURL=TableCellTemplate.lit.js.map